import { cn } from '../../lib/utils'
import { CheckedSvgIcon } from '../util/images'
import React from 'react'

interface CompletedBadgeProps {
  className?: string
}

export const CompletedBadge = ({ className }: CompletedBadgeProps): React.ReactElement => {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center self-start px-2 py-1 rounded-full',
        'bg-ivory text-primary-gray',
        className,
      )}
    >
      <span className="mr-1.5 text-xs text-primary-gray font-roboto-condensed">Completed</span>
      <CheckedSvgIcon className="h-4 w-4" />
    </div>
  )
}
